import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { DigitalIdentityComponent } from './digital-identity.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { DigitalIdentityAuthoringToolsComponent } from './authoring-tools/digital-identity-authoring-tools.component';
import { DigitalIdentityToolsComponent } from './digital-identity-tools/digital-identity-tools.component';
import { digitalIdentityRouter } from './digital-identity.router';
import { routes } from 'src/app/app.router';
import { ProfileComponent } from './shared/profile/profile.component';
import { IdentityProvisioningComponent } from './identity-provisioning/identity-provisioning.component';
import { DashboardComponent } from './authoring-tools/dashboard/dashboard.component';
import { ImportEmpInfoComponent } from './identity-provisioning/import-emp-info/import-emp-info.component';
import { AggregateEmpDetailComponent } from './identity-provisioning/aggregate-emp-detail/aggregate-emp-detail.component';
import { AssignDigitalIdComponent } from './identity-provisioning/assign-digital-id/assign-digital-id.component';
import { IdentityAdminPanelComponent } from './identity-admin-panel/identity-admin-panel.component';
import {ImportFailDialogComponent } from './shared/dialogs/import-fail-dialog.component';
import { AuditTrailAuthComponent } from './audit-trail-auth/audit-trail-auth.component';
import { TerminationAuditDetailsComponent } from './audit-trail-auth/termination-audit-details/termination-audit-details.component';
import { TransferAuditDetailsComponent } from './audit-trail-auth/transfer-audit-details/transfer-audit-details.component';

import { TerminateDialogComponent } from './shared/dialogs/terminate-dialog.component';
import { TransferEmpComponent } from './identity-admin-panel/transfer-emp/transfer-emp.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TransferOrgUnitComponent } from './identity-admin-panel/transfer-org-unit/transfer-org-unit.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SuccessDialogComponent } from './shared/dialogs/success-dialog/success-dialog.component';
import  { DeleteDialogComponent } from './shared/dialogs/delete-dialog/delete-dialog.component';
import { ReportsComponent } from './reports/reports.component';
import { NgChartsModule } from 'ng2-charts';
import { ImportDialogComponent } from './shared/dialogs/import-dialog/import-dialog.component';

@NgModule({
  declarations: [
    
   // DigitalIdentityAuthoringToolsComponent,
    DigitalIdentityToolsComponent,
    ProfileComponent,
    IdentityProvisioningComponent,
    DashboardComponent,
    ImportEmpInfoComponent,
    AggregateEmpDetailComponent,
    AssignDigitalIdComponent,
    IdentityAdminPanelComponent,
    ImportFailDialogComponent,
    AuditTrailAuthComponent,
    TerminationAuditDetailsComponent,
    TransferAuditDetailsComponent,
    TerminateDialogComponent,
    TransferEmpComponent,
    TransferOrgUnitComponent,
    SuccessDialogComponent,
    DeleteDialogComponent,
    ReportsComponent,
    ImportDialogComponent
  ],
  imports: [
    digitalIdentityRouter,
    routes,
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgbModule,
    NgChartsModule 
  ]
})
export class DigitalIdentityModule { }


